module.exports = __webpack_public_path__ + "static/img/6.35c09a0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/1/zh/6.png
// module id = CuWG
// module chunks = 0